var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
var segmentStyles = {
    root: function (_a) {
        var p = _a.props, v = _a.variables;
        var segmentColor = _.get(v.colors, p.color);
        return __assign({ padding: v.padding, borderTop: "2px solid transparent", borderRadius: v.borderRadius, boxShadow: "0 1px 1px 1px " + v.boxShadowColor, color: v.color, backgroundColor: v.backgroundColor, borderColor: segmentColor }, (p.inverted && {
            color: v.backgroundColor,
            backgroundColor: segmentColor || v.color,
        }));
    },
};
export default segmentStyles;
